'use es6';

import getIn from 'transmute/getIn';
import { CAN_VIEW_INBOX, ROUTABLE, USER_IN_PORTAL } from '../constants/keyPaths';
export const getCanViewInbox = getIn(CAN_VIEW_INBOX);
export const getIsRoutable = getIn(ROUTABLE);
export const getIsUserInPortal = getIn(USER_IN_PORTAL);